import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Checkbox, Grid, IconButton, List, ListItem, TextField, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import FormElement from "../../../components/JamezzTable/FormElement";
import { AsyncProductAutocomplete } from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { DefaultOptionForAsyncProductAutocomplete } from "../../../components/Forms/AsyncAutocomplete/Product/DefaultOptionForAsyncProductAutocomplete";
import { ProductsList } from "../../../../../Domains/OptionGroups/Categories/ProductsInCategories";
import { FormattedNumber } from "react-intl";

export default function ChildProducts() {
  const { control, vestiging } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "child_products",
    keyName: "key",
  });

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <List>
                <ListItem>
                  <Grid container>
                    <Grid item xs={2}>
                      <TranslationWrapper tKey={"Product name"} />
                    </Grid>
                    <Grid item xs={2}>
                      <TranslationWrapper tKey={"Custom price"} />
                    </Grid>
                    <Grid item xs={2}>
                      <TranslationWrapper tKey={"Default sort key"} />
                    </Grid>
                    <Grid item xs={2}>
                      <TranslationWrapper tKey={"Sort key"} />
                    </Grid>
                    <Grid item xs={2}>
                      <TranslationWrapper tKey={"Visible in Jamezz"} />
                    </Grid>
                    <Grid item xs={2} />
                  </Grid>
                </ListItem>

                {fields.map((field, index) => {
                  return (
                    <ListItem>
                      <Grid container>
                        <Grid item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.naam} -{" "}
                            <FormattedNumber
                              currency={vestiging?.valuta ?? "EUR"}
                              style={"currency"}
                              value={field.prijs}
                            />
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement endPoint={"core/optionGroupProducts"} name={"price"} row={field.pivot}>
                                <TextField
                                  placeholder={field.pivot?.price ?? field.prijs}
                                  size={"small"}
                                  variant={"standard"}
                                />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>{field.sortkey}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement endPoint={"core/optionGroupProducts"} name={"sort_key"} row={field.pivot}>
                                <TextField
                                  placeholder={field.pivot?.sort_key ?? field.sortkey}
                                  size={"small"}
                                  variant={"standard"}
                                />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement
                                askForConfirmation={false}
                                endPoint={"core/optionGroupProducts"}
                                name={"is_active_in_jamezz"}
                                parseBoolToInt={true}
                                row={field.pivot}
                                showLoadingSpinner={false}
                                valueKey={"checked"}
                              >
                                <Checkbox color={"primary"} />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <IconButton
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <Delete />
                          </IconButton>

                          <Link to={`/manager/producten/${field.id}/edit`}>
                            <Tooltip
                              classes={{}}
                              placement={"bottom"}
                              title={
                                <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                              }
                            >
                              <Button color={"success"} simple>
                                <Edit />
                              </Button>
                            </Tooltip>
                          </Link>
                        </Grid>
                      </Grid>
                    </ListItem>
                  );
                })}
              </List>

              {/*</div>*/}
              {/*)}*/}
              {/*</Draggable>*/}
              {/*))}*/}
              {/*{provided.placeholder}*/}
              {/*</Box>*/}
              {/*)}*/}
              {/*</Droppable>*/}
              {/*</DragDropContext>*/}

              {/*<AsyncRelationField*/}
              {/*  // fieldProps={fieldProps}*/}
              {/*  key={"child_products" + menukaartVestigingId}*/}
              {/*  name={"child_products"}*/}
              {/*  tKey={"producten.form.childProducts"}*/}
              {/*  tDefault={"Option Items"}*/}
              {/*  async={{*/}
              {/*    url:*/}
              {/*      "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +*/}
              {/*      menukaartVestigingId,*/}
              {/*    searchField: "naam",*/}
              {/*  }}*/}
              {/*  multiple={true}*/}
              {/*/>*/}
            </Grid>
          </Grid>

          <AddChildProduct append={append} />
        </CardBody>
      </Card>
      <ProductsList products={fields} />
    </>
  );
}

function AddChildProduct({ append }) {
  // const { paper } = autocompleteStyles();
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer, vestiging } = useFormContext();
  const [product, setProduct] = useState(null);

  return (
    <>
      <AsyncProductAutocomplete
        async_url={`core/producten/search?fields=id as value,id,naam as label,id,vestiging_id,naam,snaam,sortkey,is_actief,blocked,prijs&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`}
        autocompleteProps={{
          renderOption: (props, option) => {
            return (
              <li
                {...props}
                key={option.value}
                style={{
                  display: "grid",
                  gap: "8px",
                  gridTemplateColumns: "minmax(80px, min-content) minmax(40%, auto) minmax(min-content, auto)",
                }}
              >
                <Typography style={{ color: "#999" }}>#{option.id}</Typography>
                <span>
                  <DefaultOptionForAsyncProductAutocomplete option={option} />
                </span>
                <FormattedNumber currency={vestiging?.valuta ?? "EUR"} style={"currency"} value={option.price} />
              </li>
            );
          },
        }}
        defaultValue={product}
        onChange={setProduct}
      />
      <Button
        disabled={!product}
        onClick={() => {
          setProduct(null);
          append(product);
        }}
      >
        <TranslationWrapper tKey={"Add product"} />
      </Button>
    </>
  );
}
